module.exports = __webpack_public_path__ + "img/ac-mobile-default.00df31d9.png";